import { useEffect } from "react";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

const useGsapAnimations = () => {
  useEffect(() => {
    
    const deviceWidth = window.innerWidth;

    // Hero-2 animation
    const heroTimeline = gsap.timeline();
    const split = new SplitText(".hero-2__title, .hero-2__subtitle", { type: "words" });

    heroTimeline.from(split.chars, {
      opacity: 1,
      y: 50,
      duration: 1,
      ease: "back",
      stagger: 0.05,
    });
    heroTimeline.fromTo(
      ".secondary-img",
      { opacity: 0, scale: 0.7, ease: "back" },
      { opacity: 1, scale: 1, ease: "back" },
      "-=1"
    );
    heroTimeline.fromTo(
      ".main-img",
      { opacity: 0, scale: 0.7, ease: "back" },
      { opacity: 1, scale: 1, ease: "back" },
      ">-0.2"
    );

    // Title animation on scroll
  
      const splitTitleLines = gsap.utils.toArray(".title-anim");
      splitTitleLines.forEach((el) => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 90%",
            end: "bottom 60%",
            toggleActions: "play none none none",
          },
        });
        const splitText = new SplitText(el, { type: "words, lines" });
        gsap.set(el, { perspective: 400 });

        tl.from(splitText.lines, {
          opacity: 0,
          rotationX: -80,
          transformOrigin: "top center -50",
          ease: "power3.out",
          stagger: 0.3,
          duration: 1,
        });
      });
    

    // Character animation
    document.querySelectorAll(".animation__char_come").forEach((el) => {
      const splitChar = new SplitText(el, { type: "chars, words" });
      gsap.from(splitChar.chars, {
        x: 70,
        autoAlpha: 0,
        duration: 1,
        stagger: 0.06,
      });
    });

    // Word animations
    document.querySelectorAll(".animation__word_come").forEach((el) => {
      const split = new SplitText(el, { type: "chars words" });
      gsap.from(split.words, {
        x: 50,
        autoAlpha: 0,
        duration: 1,
        stagger: 0.05,
      });
    });

    document.querySelectorAll(".animation__word_come_long").forEach((el) => {
      const split = new SplitText(el, { type: "chars words" });
      gsap.from(split.words, {
        x: 50,
        autoAlpha: 0,
        duration: 1,
        stagger: 0.5,
      });
    });

    // Paragraph text line animations
    if (deviceWidth > 576) {
      document.querySelectorAll(".p-text").forEach((elem) => {
        const innerSplit = new SplitText(elem, {
          type: "lines",
          linesClass: "text-line",
        });
        // const outerSplit = new SplitText(elem, {
        //   type: "lines",
        //   linesClass: "text-mask",
        // });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: elem,
            start: "top 90%",
            end: "bottom 0%",
          },
          onComplete: () => {
            // outerSplit.revert();
            // innerSplit.revert();
          },
        });

        tl.to(innerSplit.lines, {
          autoAlpha: 1,
          y: 0,
          ease: "power2.out",
          duration: 1.3,
          stagger: 0.2,
        });
      });
    }

    // Skew in up animation
    if (deviceWidth > 576) {
      document.querySelectorAll(".anim-skewinup").forEach((el) => {
        gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            //  toggleActions: 'play none none none',
          },
        }).from(el, {
         duration: 1.5,
				 stagger: 0.1,
				transformOrigin: "left top",
				autoAlpha: 0,
				y: 100,
				ease: 'expo.inOut',
				clearProps: "all"
        },"+=0.3");
      });
    }

    // bdFadeUp
    if (deviceWidth > 576) {
      gsap.set(".bdFadeUp", { y: 50, opacity: 0 });
      gsap.utils.toArray(".bdFadeUp").forEach((el) => {
        gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top bottom-=150",
          },
        }).to(el, {
          y: 0,
          opacity: 1,
          ease: "power2.out",
          duration: 2,
        });
      });
    }

    // bdFadeLeft
    if (deviceWidth > 576) {
      gsap.set(".bdFadeLeft", { x: -80, opacity: 0 });
      gsap.utils.toArray(".bdFadeLeft").forEach((el) => {
        gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top center+=200",
          },
        }).to(el, {
          x: 0,
          opacity: 1,
          ease: "power2.out",
          duration: 2,
        });
      });
    }

    // bdFadeRight
    if (deviceWidth > 576) {
      gsap.set(".bdFadeRight", { x: 80, opacity: 0 });
      gsap.utils.toArray(".bdFadeRight").forEach((el) => {
        gsap.timeline({
          scrollTrigger: {
            trigger: el,
            start: "top center+=200",
          },
        }).to(el, {
          x: 0,
          opacity: 1,
          ease: "power2.out",
          duration: 2,
        });
      });
    }

  }, []);
};

export default useGsapAnimations;
